module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/verbytska-art-bkg-ee3cbaf1dba5357eb966a98523bfcfa9.jpg";